export { GMaps } from './GoogleMap';
